import { render } from "./UpdateInfos.vue?vue&type=template&id=a1c07a3a"
import script from "./UpdateInfos.vue?vue&type=script&lang=js"
export * from "./UpdateInfos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__